export default {
  title: '工厂管理',
  addFactory: '添加工厂',
  factoryInfo: '工厂信息',
  factoryInfoPlaceholder: '请输入工厂编号、工厂名称',
  langRequired: '请选择语言版本',
  factoryNo: '工厂编号',
  factoryName: '工厂名称',
  factoryAddress: '工厂地址',
  addModal: '添加工厂',
  editModal: '编辑工厂',
  factoryNoPlaceholder: '请输入工厂编号',
  factoryNamePlaceholder: '请输入工厂名称',
  factoryAddressPlaceholder: '请输入工厂地址',
  requiredFactoryNo: '请输入工厂编号',
  requiredFactoryName: '请输入工厂名称',
};
